import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { GaugeChart } from 'echarts/charts';
import { GridComponent, TooltipComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { getColor } from 'helpers/utils';
import { useEffect, useState } from 'react';
echarts.use([GaugeChart, TooltipComponent, GridComponent, CanvasRenderer]);
import ClassService from 'components/app/wod/classes/ClassService';

const getGaugeOption = (value, color) => ({
  series: [
    {
      type: 'gauge',
      startAngle: 180,
      endAngle: 0,
      min: 0,
      max: 100,
      radius: '100%',
      center: ['50%', '85%'],
      pointer: {
        show: true,
        length: '55%',
        width: 4,
        itemStyle: {
          color: getColor('dark')
        }
      },
      progress: {
        show: true,
        overlap: false,
        roundCap: true,
        clip: false,
        itemStyle: {
          color
        }
      },
      axisLine: {
        roundCap: true,
        lineStyle: {
          width: 8,
          color: [[1, getColor('200')]]
        }
      },
      splitLine: { show: false },
      axisTick: { show: false },
      axisLabel: { show: false },
      anchor: { show: false },
      title: { show: false },
      detail: { show: false },
      data: [{ value }]
    }
  ]
});

const ActivityGauge = ({ label, value, change, color }) => (
  <div className="text-center">
    <p className="text-body-tertiary mb-1">{label}</p>
    <ReactEChartsCore
      echarts={echarts}
      option={getGaugeOption(value, color)}
      style={{ height: '80px', width: '100%' }}
    />
    <h5 className="fw-bold mb-0 mt-1">{value.toFixed(1)}%</h5>
    <small className="text-warning">{change.toFixed(1)}%</small>
  </div>
);

const CustomerActivityCard = ({ mockData }) => {
  const [data, setData] = useState();
  useEffect(() => {
    ClassService.customerActivityByAccount()
      .then(data => {
        const updatedData =  mockData || data; // Use mockData if provided, otherwise use fetched data
        setData(updatedData);
      })
      .catch(error => {
        console.error('Error retrieving customer activity:', error);
      });
+
    console.log('Customer activity data:', data);
  }, []);
  return (
    <>
      {data && (<Card className="h-100 border-0 shadow-sm">
      <Card.Body>
        <p className="text-body-tertiary mb-3">Customer Activity</p>
        <Row className="g-3">
          <Col xs={4}>
            <ActivityGauge
              label="Active"
              value={data.active.percentage}
              change={data.active.change}
              color={getColor('success')}
            />
          </Col>
          <Col xs={4}>
            <ActivityGauge
              label="Semi-active"
              value={data.semiActive.percentage}
              change={data.semiActive.change}
              color={getColor('warning')}
            />
          </Col>
          <Col xs={4}>
            <ActivityGauge
              label="Inactive"
              value={data.inactive.percentage}
              change={data.inactive.change}
              color={getColor('danger')}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>)}
    </>

  );
};

export default CustomerActivityCard;
